module.exports = __webpack_public_path__ + "static/media/icon-exclamation.960e7048.svg";